(function(){
'use strict';
var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
var FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;
function $(s,r){return (r||document).querySelector(s);}
function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
var SA = window.SA || {};
var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
function formatMoney(cents,format){
if(typeof cents==='string')cents=cents.replace('.','');
cents=Number(cents)||0;
format=String(format||SA.moneyFormat||'${{amount}}').replace(/<[^>]*>/g,'');
function f(n,dec,th,d){th=th||',';d=d||'.';var s=(n/100).toFixed(dec).split('.');return s[0].replace(/\B(?=(\d{3})+(?!\d))/g,th)+(s[1]?d+s[1]:'');}
var m=format.match(/\{\{\s*(\w+)\s*\}\}/),v;
switch(m?m[1]:'amount'){
case 'amount_no_decimals':v=f(cents,0);break;
case 'amount_with_comma_separator':v=f(cents,2,'.',',');break;
case 'amount_no_decimals_with_comma_separator':v=f(cents,0,'.',',');break;
case 'amount_with_apostrophe_separator':v=f(cents,2,"'",'.');break;
case 'amount_with_space_separator':v=f(cents,2,' ',',');break;
default:v=f(cents,2);
}
return format.replace(/\{\{\s*\w+\s*\}\}/,v);
}
function imgUrl(src,w){
if(!src)return '';
if(typeof src==='object')src=src.src||src.url||'';
if(src.indexOf('//')===0)src='https:'+src;
return src+(src.indexOf('?')>-1?'&':'?')+'width='+w;
}
function lockScroll(on){document.documentElement.style.overflow=on?'hidden':'';}
var toastT=0;
function toast(msg){var t=$('#saToast');if(!t)return;t.textContent=msg;t.classList.add('show');clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove('show');},2400);}
function postJSON(url,body){
return fetch(ROOT+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
.then(function(r){return r.json().catch(function(){return {};}).then(function(d){if(!r.ok)throw new Error(d.description||d.message||'Something went wrong. Try again.');return d;});});
}
var Cart = {
refresh:function(){return fetch(ROOT+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){Cart.render(c);return c;});},
add:function(id,qty){return postJSON('cart/add.js',{items:[{id:Number(id),quantity:qty||1}]}).then(function(){var b=$('.bag-btn');if(b){b.classList.remove('bump');void b.offsetWidth;b.classList.add('bump');}return Cart.refresh();});},
change:function(key,qty){return postJSON('cart/change.js',{id:key,quantity:qty}).then(function(c){Cart.render(c);return c;});},
render:function(c){
$$('[data-cart-count]').forEach(function(e){e.textContent=c.item_count;});
var list=$('#saDrawerList'),foot=$('#saDrawerFoot');
if(!list)return;
if(!c.items.length){
list.innerHTML='<li class="d-empty"><span>Your bag is empty.</span><a class="btn btn-ghost" href="'+esc(rackUrl())+'">Walk the rack</a></li>';
foot.hidden=true;return;
}
foot.hidden=false;
list.innerHTML=c.items.map(function(it){
var opts=(it.options_with_values||[]).filter(function(o){return o.name!=='Title';}).map(function(o){return esc(o.name)+' '+esc(o.value);}).join(' · ');
var img=it.image?'<img src="'+esc(imgUrl(it.image,200))+'" alt="" loading="lazy">':'';
return '<li class="d-item"><a class="d-thumb" href="'+esc(it.url)+'">'+img+'</a><div><h3><a href="'+esc(it.url)+'">'+esc(it.product_title)+'</a></h3>'+(opts?'<div class="meta">'+opts+'</div>':'')+
'<div class="qty"><button type="button" data-q="'+(it.quantity-1)+'" data-key="'+esc(it.key)+'" aria-label="One fewer">−</button><span>'+it.quantity+'</span><button type="button" data-q="'+(it.quantity+1)+'" data-key="'+esc(it.key)+'" aria-label="One more">+</button></div></div>'+
'<div><div class="d-price">'+esc(formatMoney(it.final_line_price))+'</div><button type="button" class="rm" data-q="0" data-key="'+esc(it.key)+'">Remove</button></div></li>';
}).join('');
$('#saSubtotal').textContent=formatMoney(c.total_price);
var ship=$('#saShip'),th=Number(SA.freeShipping)||0;
if(ship){
if(th>0){var left=th-c.total_price;ship.hidden=false;
ship.innerHTML=esc(left>0?'Add '+formatMoney(left)+' more for free shipping':'Free shipping unlocked')+'<div class="ship-bar"><i style="width:'+Math.min(100,Math.round(c.total_price/th*100))+'%"></i></div>';}
else ship.hidden=true;
}
}
};
function rackUrl(){var a=$('[data-rack-url]');return a?a.getAttribute('data-rack-url'):ROOT+'pages/the-rack';}
var drawer=null,drawerReturn=null;
function openDrawer(){
drawer=drawer||$('#saDrawer');
if(!drawer||document.body.classList.contains('template-cart')){location.href=SA.cartUrl||ROOT+'cart';return;}
if(!drawer.hidden)return;
drawerReturn=document.activeElement;
drawer.hidden=false;lockScroll(true);
Cart.refresh();
requestAnimationFrame(function(){drawer.classList.add('open');});
var x=$('.x-btn',drawer);if(x)x.focus({preventScroll:true});
}
function closeDrawer(){
if(!drawer||drawer.hidden)return;
drawer.classList.remove('open');
setTimeout(function(){drawer.hidden=true;if(!QV||QV.m.hidden)lockScroll(false);},RM?0:400);
if(drawerReturn&&drawerReturn.focus)drawerReturn.focus({preventScroll:true});
}
document.addEventListener('click',function(e){
var open=e.target.closest('[data-open-cart]');
if(open&&!document.body.classList.contains('template-cart')){e.preventDefault();openDrawer();return;}
if(e.target.closest('[data-dclose]')){closeDrawer();return;}
var q=e.target.closest('#saDrawerList [data-q]');
if(q){q.disabled=true;Cart.change(q.getAttribute('data-key'),Number(q.getAttribute('data-q'))).catch(function(err){toast(err.message);});}
});
function ProductView(root,opts){
opts=opts||{};
this.root=root;this.isPage=!!opts.isPage;this.onAdded=opts.onAdded;
this.stage=$('[data-stage]',root);this.spin=$('[data-spin]',root);
this.front=$('[data-front]',root);this.back=$('[data-back]',root);
this.turn=$('[data-turn]',root);this.fBtn=$('[data-face="front"]',root);this.bBtn=$('[data-face="back"]',root);this.hint=$('[data-hint]',root);
this.optsBox=$('[data-options]',root);this.priceEl=$('[data-price]',root);this.compareEl=$('[data-compare]',root);
this.addBtn=$('[data-add]',root);this.err=$('[data-error]',root);
this.M={ang:0,target:0,vel:0,drag:false,px:0,hx:0,hy:0,raf:0,running:false,hasBack:false};
var self=this,M=this.M;
this.bindStage();
if(this.addBtn)this.addBtn.addEventListener('click',function(){self.addToCart();});
if(this.optsBox)this.optsBox.addEventListener('click',function(e){var b=e.target.closest('[data-opt]');if(!b)return;self.sel[Number(b.getAttribute('data-i'))]=b.getAttribute('data-v');if(self.err)self.err.hidden=true;self.update(false);});
if(this.fBtn)this.fBtn.addEventListener('click',function(){M.vel=0;M.target=Math.round(M.ang/360)*360;});
if(this.bBtn)this.bBtn.addEventListener('click',function(){M.vel=0;M.target=Math.round((M.ang-180)/360)*360+180;});
}
ProductView.prototype.optName=function(i){var o=this.p.options[i];return typeof o==='string'?o:(o&&o.name)||'option';};
ProductView.prototype.load=function(p,variantId){
this.p=p;
var vs=p.variants,v=null,i;
if(variantId)for(i=0;i<vs.length;i++)if(String(vs[i].id)===String(variantId))v=vs[i];
var explicit=!!v;
if(!v){for(i=0;i<vs.length;i++)if(vs[i].available){v=vs[i];break;}v=v||vs[0];}
this.single=vs.length===1&&/^default title$/i.test(vs[0].title);
this.sel=v.options.slice();
if(!explicit&&!this.single&&vs.length>1){
for(i=0;i<p.options.length;i++)if(/size|taille|gr[öo]ße|talla|taglia/i.test(this.optName(i))){this.sel[i]=null;break;}
}
var imgs=p.images||[];
this.frontSrc=p.featured_image||imgs[0]||'';
this.backSrc=imgs[1]||'';
this._front=null;
this.setImages(explicit&&v.featured_image?v.featured_image.src:null);
this.renderOptions();
this.update(true);
this.M.ang=RM?0:-26;this.M.target=0;this.M.vel=0;this.M.hx=this.M.hy=0;
};
ProductView.prototype.setImages=function(frontOverride){
var f=frontOverride||this.frontSrc;
if(this.front&&f&&f!==this._front){
if(this._front!==null||!this.isPage){this.front.removeAttribute('srcset');this.front.src=imgUrl(f,1200);}
this.front.alt=this.p.title;this._front=f;
}
this.M.hasBack=!!this.backSrc;
if(this.back){if(this.backSrc){if(!this.isPage||!this.back.getAttribute('src')){this.back.removeAttribute('srcset');this.back.src=imgUrl(this.backSrc,1200);}this.back.alt=this.p.title+', back';}}
if(this.fBtn){this.fBtn.hidden=!this.backSrc;this.bBtn.hidden=!this.backSrc;}
if(this.hint)this.hint.textContent=this.backSrc?'Drag to turn':'Drag to tilt';
};
ProductView.prototype.showFront=function(src){this.setImages(src);this.M.vel=0;this.M.target=Math.round(this.M.ang/360)*360;};
ProductView.prototype.renderOptions=function(){
var box=this.optsBox;if(!box)return;box.innerHTML='';
if(this.single)return;
var p=this.p,self=this;
p.options.forEach(function(o,i){
var seen={},vals=[];
p.variants.forEach(function(v){if(!seen[v.options[i]]){seen[v.options[i]]=1;vals.push(v.options[i]);}});
var fs=document.createElement('fieldset');fs.className='sizes';
fs.innerHTML='<legend class="label">'+esc(self.optName(i))+'</legend><div class="size-row">'+vals.map(function(v){return '<button type="button" class="size" data-opt data-i="'+i+'" data-v="'+esc(v)+'" aria-pressed="false">'+esc(v)+'</button>';}).join('')+'</div>';
box.appendChild(fs);
});
};
ProductView.prototype.current=function(){
var sel=this.sel;
if(sel.some(function(s){return s==null;}))return null;
return this.p.variants.filter(function(v){return v.options.every(function(o,i){return o===sel[i];});})[0]||null;
};
ProductView.prototype.update=function(initial){
var p=this.p,v=this.current(),sel=this.sel;
$$('[data-opt]',this.root).forEach(function(b){
var i=Number(b.getAttribute('data-i')),val=b.getAttribute('data-v');
var ok=p.variants.some(function(x){return x.available&&x.options[i]===val&&x.options.every(function(o,j){return j===i||sel[j]==null||o===sel[j];});});
b.classList.toggle('na',!ok);b.setAttribute('aria-pressed',String(sel[i]===val));b.title=ok?'':'Sold out';
});
var price=v?v.price:p.price,cmp=v?v.compare_at_price:p.compare_at_price;
if(this.priceEl)this.priceEl.textContent=(!v&&p.price_varies?'From ':'')+formatMoney(price);
if(this.compareEl){if(cmp&&cmp>price){this.compareEl.hidden=false;this.compareEl.textContent=formatMoney(cmp);}else this.compareEl.hidden=true;}
if(this.addBtn){
var sold=(v&&!v.available)||!p.available;
this.addBtn.disabled=sold;this.addBtn.textContent=sold?'Sold out':'Add to bag';
}
if(!initial&&v&&v.featured_image)this.showFront(v.featured_image.src);
if(this.isPage&&v&&!initial){try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString());}catch(e){}}
var idInput=$('[data-variant-id]',this.root);if(idInput&&v)idInput.value=v.id;
};
ProductView.prototype.addToCart=function(){
var self=this,v=this.current();
if(!v){
var miss=0;for(var i=0;i<this.sel.length;i++)if(this.sel[i]==null){miss=i;break;}
if(this.err){this.err.textContent='Pick a '+this.optName(miss).toLowerCase()+' first.';this.err.hidden=false;}
return;
}
this.addBtn.disabled=true;this.addBtn.textContent='Adding…';
Cart.add(v.id,1).then(function(){
toast(self.p.title+(self.single?'':' · '+v.title)+' added to bag');
if(self.onAdded)self.onAdded();
if(SA.openDrawer)setTimeout(openDrawer,self.onAdded?320:0);
}).catch(function(e){if(self.err){self.err.textContent=e.message;self.err.hidden=false;}})
.then(function(){self.update(true);});
};
ProductView.prototype.bindStage=function(){
var M=this.M,st=this.stage;if(!st)return;
st.addEventListener('pointerdown',function(e){if(e.target.closest('button,a'))return;M.drag=true;M.px=e.clientX;M.vel=0;st.classList.add('dragging');try{st.setPointerCapture(e.pointerId);}catch(_){}});
st.addEventListener('pointermove',function(e){
var r=st.getBoundingClientRect();
if(M.drag){var dx=e.clientX-M.px;M.px=e.clientX;M.ang+=dx*.6;M.vel=dx*.6;if(!M.hasBack)M.ang=Math.max(-40,Math.min(40,M.ang));}
else if(e.pointerType==='mouse'&&!RM){M.hx=((e.clientX-r.left)/r.width-.5)*24;M.hy=-((e.clientY-r.top)/r.height-.5)*12;}
});
function end(){if(!M.drag)return;M.drag=false;st.classList.remove('dragging');
if(!M.hasBack){M.vel=0;M.target=0;return;}
if(Math.abs(M.vel)<.6||RM){M.target=Math.round(M.ang/180)*180;M.vel=0;}}
st.addEventListener('pointerup',end);st.addEventListener('pointercancel',end);
st.addEventListener('pointerleave',function(){M.hx=0;M.hy=0;});
};
ProductView.prototype.tick=function(){
var M=this.M,self=this;if(!M.running)return;
if(!M.drag){
if(Math.abs(M.vel)>.05&&!RM&&M.hasBack){M.ang+=M.vel;M.vel*=.93;if(Math.abs(M.vel)<.6){M.target=Math.round(M.ang/180)*180;M.vel=0;}}
else M.ang+=(M.target-M.ang)*(RM?1:.09);
}
var face=((Math.round(M.ang/180)%2)+2)%2;
if(this.fBtn){this.fBtn.classList.toggle('on',face===0);this.bBtn.classList.toggle('on',face===1);}
if(this.spin)this.spin.style.transform='rotateX('+M.hy.toFixed(2)+'deg) rotateY('+(M.ang+M.hx).toFixed(2)+'deg)';
M.raf=requestAnimationFrame(function(){self.tick();});
};
ProductView.prototype.start=function(){if(this.M.running)return;this.M.running=true;this.tick();};
ProductView.prototype.stop=function(){this.M.running=false;cancelAnimationFrame(this.M.raf);};
var QV=null;
function getQV(){
if(QV)return QV;
var m=$('#saQuick');if(!m)return null;
QV={m:m,last:null,view:new ProductView($('[data-product-view]',m),{onAdded:closeQuick})};
m.addEventListener('click',function(e){if(e.target.closest('[data-close]'))closeQuick();});
return QV;
}
function productData(id){
var s=$('script[data-product-json="'+id+'"]');
if(!s)return null;
try{return JSON.parse(s.textContent);}catch(e){return null;}
}
function openQuick(p,from){
var q=getQV();if(!q){location.href=p.url;return;}
q.last=from||document.activeElement;
q.view.load(p);
$('[data-qv-title]',q.m).textContent=p.title;
$('[data-qv-type]',q.m).textContent=[p.vendor,p.type].filter(Boolean).join(' · ');
var d=document.createElement('div');d.innerHTML=p.description||'';var txt=(d.textContent||'').trim();
$('[data-qv-desc]',q.m).textContent=txt.length>260?txt.slice(0,257).replace(/\s+\S*$/,'')+'…':txt;
$('[data-qv-link]',q.m).href=p.url;
if(q.view.err)q.view.err.hidden=true;
q.m.hidden=false;lockScroll(true);
requestAnimationFrame(function(){q.m.classList.add('open');});
var x=$('.x-btn',q.m);if(x)x.focus({preventScroll:true});
q.view.start();
}
function closeQuick(){
var q=QV;if(!q||q.m.hidden)return;
q.m.classList.remove('open');q.view.stop();
setTimeout(function(){q.m.hidden=true;if(!drawer||drawer.hidden)lockScroll(false);},RM?0:300);
if(q.last&&q.last.focus)q.last.focus({preventScroll:true});
}
document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;if(QV&&!QV.m.hidden)closeQuick();else closeDrawer();});
function initProductPage(root){
if(root._sa)return;root._sa=1;
var s=$('script[data-product-json]',root);if(!s)return;
var p;try{p=JSON.parse(s.textContent);}catch(e){return;}
var view=new ProductView(root,{isPage:true});
view.load(p,root.getAttribute('data-initial-variant'));
$$('[data-thumb]',root).forEach(function(t){
t.addEventListener('click',function(){$$('[data-thumb]',root).forEach(function(o){o.classList.toggle('on',o===t);});view.showFront(t.getAttribute('data-thumb'));});
});
if('IntersectionObserver' in window){new IntersectionObserver(function(es){es[0].isIntersecting?view.start():view.stop();}).observe(view.stage||root);}
else view.start();
}
function initTilt(scope){
if(!FINE||RM)return;
$$('[data-tilt]',scope).forEach(function(el){
if(el._sa)return;el._sa=1;
var max=Number(el.getAttribute('data-tilt'))||12;
el.addEventListener('pointermove',function(e){
var r=el.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
el.classList.add('tracking');
el.style.setProperty('--rx',((.5-y)*max).toFixed(2)+'deg');el.style.setProperty('--ry',((x-.5)*max).toFixed(2)+'deg');
el.style.setProperty('--mx',(x*100).toFixed(1)+'%');el.style.setProperty('--my',(y*100).toFixed(1)+'%');
});
el.addEventListener('pointerleave',function(){el.classList.remove('tracking');el.style.setProperty('--rx','0deg');el.style.setProperty('--ry','0deg');});
});
}
function initDemo(scope){
if(!window.SAGarments)return;
$$('[data-demo-garment]',scope).forEach(function(el){if(!el.firstChild)el.innerHTML=SAGarments.svg(el.getAttribute('data-demo-garment'));});
}
function initRack(sec){
if(sec._sa)return;sec._sa=1;
var rail=$('[data-rail]',sec);if(!rail)return;
var items=$$('.item',rail),filterBox=$('[data-filters]',sec),countEl=$('[data-rack-count]',sec),filter='all',queued=false;
function visible(){return items.filter(function(i){return !i.hidden;});}
function update(){
queued=false;
var r=rail.getBoundingClientRect();if(!r.width)return;
var cx=r.left+r.width/2,half=r.width/2;
items.forEach(function(it){
if(it.hidden)return;
var b=it.getBoundingClientRect(),o=Math.max(-1.5,Math.min(1.5,(b.left+b.width/2-cx)/half));
it.style.setProperty('--ry',(-o*50).toFixed(1)+'deg');
it.style.setProperty('--tz',(-Math.abs(o)*90).toFixed(1)+'px');
it.style.zIndex=String(100-Math.round(Math.abs(o)*40));
});
}
function queue(){if(!queued){queued=true;requestAnimationFrame(update);}}
function centerOn(idx){var it=visible()[idx];if(!it)return;rail.scrollLeft=it.offsetLeft+it.offsetWidth/2-rail.clientWidth/2;}
function setFilter(f){
filter=f;
items.forEach(function(it){it.hidden=!(f==='all'||it.getAttribute('data-type')===f);});
if(filterBox)$$('.chip',filterBox).forEach(function(c){var on=c.getAttribute('data-f')===f;c.classList.toggle('on',on);c.setAttribute('aria-pressed',String(on));});
var n=visible().length;
if(countEl)countEl.textContent=n+(n===1?' piece':' pieces')+' on the rail';
requestAnimationFrame(function(){centerOn(Math.min(f==='all'?2:0,n-1));update();});
}
if(filterBox){
var types=[],labels={},counts={};
items.forEach(function(it){var t=it.getAttribute('data-type');if(!t)return;if(!counts[t]){types.push(t);labels[t]=it.getAttribute('data-type-label');counts[t]=0;}counts[t]++;});
if(types.length>1){
filterBox.innerHTML='<button type="button" class="chip on" data-f="all" aria-pressed="true">All<i>'+items.length+'</i></button>'+
types.map(function(t){return '<button type="button" class="chip" data-f="'+esc(t)+'" aria-pressed="false">'+esc(labels[t])+'<i>'+counts[t]+'</i></button>';}).join('');
filterBox.addEventListener('click',function(e){var b=e.target.closest('[data-f]');if(b)setFilter(b.getAttribute('data-f'));});
}
}
var lastX=0,swingT=0;
rail.addEventListener('scroll',function(){
var dx=rail.scrollLeft-lastX;lastX=rail.scrollLeft;
if(!RM){rail.style.setProperty('--swing',Math.max(-12,Math.min(12,-dx*.35)).toFixed(1)+'deg');clearTimeout(swingT);swingT=setTimeout(function(){rail.style.setProperty('--swing','0deg');},110);}
queue();
},{passive:true});
window.addEventListener('resize',queue);
items.forEach(function(it){it.addEventListener('pointerenter',function(e){
if(e.pointerType!=='mouse'||rail.classList.contains('dragging'))return;
var vis=visible(),i=vis.indexOf(it);
vis.forEach(function(o,j){o.style.setProperty('--push',j<i?'-30px':j>i?'30px':'0px');});
});});
rail.addEventListener('pointerleave',function(){items.forEach(function(o){o.style.setProperty('--push','0px');});});
var drag=null,suppress=false;
rail.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;drag={x:e.clientX,sl:rail.scrollLeft,moved:false};});
window.addEventListener('pointermove',function(e){
if(!drag)return;var dx=e.clientX-drag.x;
if(!drag.moved&&Math.abs(dx)>6){drag.moved=true;rail.classList.add('dragging');items.forEach(function(o){o.style.setProperty('--push','0px');});}
if(drag.moved)rail.scrollLeft=drag.sl-dx;
});
window.addEventListener('pointerup',function(){if(!drag)return;suppress=drag.moved;drag=null;rail.classList.remove('dragging');setTimeout(function(){suppress=false;},0);});
rail.addEventListener('wheel',function(e){
if(Math.abs(e.deltaY)<=Math.abs(e.deltaX))return;
var max=rail.scrollWidth-rail.clientWidth;
if((e.deltaY>0&&rail.scrollLeft<max-1)||(e.deltaY<0&&rail.scrollLeft>1)){rail.scrollLeft+=e.deltaY;e.preventDefault();}
},{passive:false});
function step(){return rail.clientWidth*.55;}
var prev=$('[data-prev]',sec),next=$('[data-next]',sec);
if(prev)prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:RM?'auto':'smooth'});});
if(next)next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:RM?'auto':'smooth'});});
rail.addEventListener('click',function(e){
var it=e.target.closest('.item');if(!it||suppress)return;
if(it.hasAttribute('data-demo')){toast('Demo piece. Add products to fill the rack.');return;}
var p=productData(it.getAttribute('data-product-id'));
if(!p)return;
it.classList.add('lift');
setTimeout(function(){openQuick(p,it);it.classList.remove('lift');},RM?0:280);
});
setFilter('all');
if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){centerOn(Math.min(2,visible().length-1));update();});
}
function initHero(sec){
var canvas=$('[data-hero-canvas]',sec);
if(!canvas||canvas._sa||!window.THREE)return;
canvas._sa=1;
var THREE=window.THREE,renderer;
try{renderer=new THREE.WebGLRenderer({canvas:canvas,antialias:true,alpha:true});}catch(e){return;}
renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
renderer.outputEncoding=THREE.sRGBEncoding;
renderer.toneMapping=THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure=1.15;
var scene=new THREE.Scene(),cam=new THREE.PerspectiveCamera(32,1,.1,100);cam.position.set(0,0,7);
var ec=document.createElement('canvas');ec.width=1024;ec.height=512;var g=ec.getContext('2d');
var gr=g.createLinearGradient(0,0,0,512);gr.addColorStop(0,'#2c2f35');gr.addColorStop(.48,'#0b0c0e');gr.addColorStop(.52,'#17191d');gr.addColorStop(1,'#000');
g.fillStyle=gr;g.fillRect(0,0,1024,512);
g.fillStyle='#ffffff';g.fillRect(110,80,90,270);g.fillRect(600,50,250,70);g.fillRect(890,130,36,230);
g.fillStyle='#d4dae4';g.fillRect(370,150,60,190);g.fillStyle='#ffffff';g.fillRect(0,240,1024,4);
var tex=new THREE.CanvasTexture(ec);tex.mapping=THREE.EquirectangularReflectionMapping;tex.encoding=THREE.sRGBEncoding;
var pm=new THREE.PMREMGenerator(renderer);scene.environment=pm.fromEquirectangular(tex).texture;tex.dispose();pm.dispose();
var chrome=new THREE.MeshStandardMaterial({color:0xffffff,metalness:1,roughness:.08});
var gun=new THREE.MeshStandardMaterial({color:0x2a2c31,metalness:1,roughness:.28});
function V(x,y,z){return new THREE.Vector3(x,y,z||0);}
var hanger=new THREE.Group();
function tube(curve,r,seg,closed){hanger.add(new THREE.Mesh(new THREE.TubeGeometry(curve,seg,r,20,closed),chrome));}
tube(new THREE.CatmullRomCurve3([V(0,.66),V(-.6,.34),V(-1.22,.03),V(-1.4,-.06),V(-1.37,-.16),V(-1.2,-.19),V(-.6,-.19),V(0,-.19),V(.6,-.19),V(1.2,-.19),V(1.37,-.16),V(1.4,-.06),V(1.22,.03),V(.6,.34)],true,'catmullrom',.15),.045,420,true);
tube(new THREE.CatmullRomCurve3([V(0,.7),V(0,.86),V(0,1.0),V(.05,1.13),V(.19,1.2),V(.33,1.13),V(.37,1.0),V(.31,.91)]),.04,120,false);
var hp=[];for(var i=0;i<=48;i++){var t=i/48,a=t*Math.PI*7;hp.push(V(Math.cos(a)*.055,.6+t*.2,Math.sin(a)*.055));}
tube(new THREE.CatmullRomCurve3(hp),.022,240,false);
var cap=new THREE.Mesh(new THREE.SphereGeometry(.042,20,14),chrome);cap.position.set(.31,.91,0);hanger.add(cap);
var rig=new THREE.Group();rig.add(hanger);scene.add(rig);
var rings=[[-.2,.1,-2.2,.9,gun],[2.2,1.4,-1.6,.42,chrome],[-2.6,-1.2,-1.2,.3,chrome]].map(function(d){var m=new THREE.Mesh(new THREE.TorusGeometry(d[3],.035,16,96),d[4]);m.position.set(d[0],d[1],d[2]);rig.add(m);return m;});
var N=260,pos=new Float32Array(N*3);for(i=0;i<N;i++){pos[i*3]=(Math.random()-.5)*12;pos[i*3+1]=(Math.random()-.5)*7;pos[i*3+2]=(Math.random()-.5)*6-1;}
var pg=new THREE.BufferGeometry();pg.setAttribute('position',new THREE.BufferAttribute(pos,3));
var dust=new THREE.Points(pg,new THREE.PointsMaterial({color:0xcfd3da,size:.022,transparent:true,opacity:.55}));scene.add(dust);
var baseY=0,mx=0,my=0,visible=true,running=false,inner=$('[data-hero-inner]',sec);
function resize(){
var w=canvas.clientWidth,h=canvas.clientHeight;if(!w||!h)return;
renderer.setSize(w,h,false);cam.aspect=w/h;cam.updateProjectionMatrix();
var H=2*cam.position.z*Math.tan(THREE.MathUtils.degToRad(cam.fov/2)),W=H*cam.aspect,s;
if(w>760){s=Math.min(1.3,(W*.4)/2.9);rig.scale.setScalar(s);rig.position.x=Math.min(W*.24,2.7);baseY=-.15;}
else{var pad=inner?parseFloat(getComputedStyle(inner).paddingTop)||300:300;s=Math.min(1,(W*.78)/2.9);rig.scale.setScalar(s);rig.position.x=0;baseY=H/2-(pad*.52/h)*H-.35*s;}
if(!running)renderer.render(scene,cam);
}
if('ResizeObserver' in window)new ResizeObserver(resize).observe(canvas);else window.addEventListener('resize',resize);
window.addEventListener('pointermove',function(e){mx=(e.clientX/innerWidth-.5)*2;my=(e.clientY/innerHeight-.5)*2;},{passive:true});
var t0=performance.now();
function frame(now){
if(!running)return;
if(!canvas.isConnected){running=false;return;}
var t=(now-t0)/1000;
hanger.rotation.y=(RM?.5:t*.45)+mx*.5;hanger.rotation.x=my*.15;hanger.rotation.z=RM?0:Math.sin(t*1.1)*.05;
rig.position.y=baseY+(RM?0:Math.sin(t*.9)*.06);
rings.forEach(function(r,k){r.rotation.x=t*(.3+k*.1);r.rotation.y=t*(.2+k*.15)+mx*.3;});
dust.rotation.y=RM?0:t*.02;
renderer.render(scene,cam);
requestAnimationFrame(frame);
}
function sync(){if(visible&&!running){running=true;requestAnimationFrame(frame);}else if(!visible)running=false;}
if('IntersectionObserver' in window)new IntersectionObserver(function(es){visible=es[0].isIntersecting;sync();}).observe(canvas);
resize();sync();
}
function initSort(scope){
$$('[data-sort]',scope).forEach(function(s){
if(s._sa)return;s._sa=1;
s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString();});
});
}
function initScope(scope){
initDemo(scope);initTilt(scope);initSort(scope);
$$('[data-rack]',scope).forEach(initRack);
$$('[data-product-page]',scope).forEach(initProductPage);
var heroes=$$('[data-hero]',scope);
if(heroes.length){
if(window.THREE)heroes.forEach(initHero);
else window.addEventListener('load',function(){heroes.forEach(initHero);});
}
}
initScope(document);
document.addEventListener('shopify:section:load',function(e){initScope(e.target);});
})();